import TouchableButton from "../../components/TouchableButton";
import ComponentThemeType from "../../models/ComponentTheme";
import ComponentTypeEnum from "../../models/ComponentTypeEnum";
import { capitalize, globalAny } from "../../utils/Utils";
import { StyledButton, StyledButtonContainer, StyledNarrowButtonContainer } from "./styled";

export const renderPreviousButton = (props: any) => (
	<TouchableButton
		componentTheme={ComponentThemeType.VinFast}
		type={ComponentTypeEnum.Secondary}
		onPress={() => (props.step > 0 ? props.onPressPrevious() : props.confirmExit("back"))}
		disabled={props.disabledPrevious}
		leftText={props.isNarrow}
	>
		{props.step > 0 ? globalAny.language.previous : globalAny.language.cancel}
	</TouchableButton>
);

export const renderNextButton = (props: any) => {
	const isLastStep = props.step >= props.steps.length - 1;
	const isRent = capitalize(props.paymentType) === props.rent;

	let buttonLabel = globalAny.language.next;

	if (isLastStep) {
		buttonLabel = isRent ? globalAny.language.rent : globalAny.language.purchase_word;
	}

	return (
		<TouchableButton
			nativeID={"payNext"}
			componentTheme={ComponentThemeType.VinFast}
			type={ComponentTypeEnum.Primary}
			onPress={() => props.onPressNext()}
			disabled={props.onValidateStep}
			leftText={props.isNarrow}
		>
			{buttonLabel}
		</TouchableButton>
	);
};

export const NarrowButton = (props: any) => (
	<>
		{/* @ts-ignores */}
		<StyledNarrowButtonContainer>
			{renderNextButton(props)}
			{renderPreviousButton(props)}
		</StyledNarrowButtonContainer>
	</>
);

export const WideButton = (props: any) => (
	<>
		{/* @ts-ignores */}
		<StyledButtonContainer>
			{/* @ts-ignores */}
			<StyledButton>{renderPreviousButton(props)}</StyledButton>
			{/* @ts-ignores */}
			<StyledButton>{renderNextButton(props)}</StyledButton>
		</StyledButtonContainer>
	</>
);

export const RenderButton = (props: any) => (props.isNarrow ? NarrowButton(props) : WideButton(props));
